// extracted by mini-css-extract-plugin
export default {"container_history":"style_container_history__KJjwH","text_history":"style_text_history__jBNP0"};